import { Provider } from "@angular/core";
import { TableConfigService } from "./service/table-config.service";
import { TableConfig } from "./table-config";

export function provideTable(config: TableConfig): Provider[] {
  return [
    {
      provide: TableConfigService,
      useValue: config
    }
  ];
}
